import { useEffect } from 'react';

import { useRouter } from '@/hooks/useRouter';
import { checkIsBackspace } from '@/utils';

const BLOCKED_KEY_CODES = [32, 33, 34, 35, 37, 38, 39, 40];

export const useBackspaceNavigation = () => {
  const router = useRouter();

  useEffect(() => {
    const handleEvent = (event: KeyboardEvent) => {
      if (checkIsBackspace(event)) {
        event.preventDefault();
        event.stopPropagation();
        router.pop();
      } else if (BLOCKED_KEY_CODES.includes(event.keyCode)) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    };
    window.addEventListener('keydown', handleEvent);

    return () => {
      window.removeEventListener('keydown', handleEvent);
    };
  }, [router]);
};
